import script from "./CRM65_001RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM65_001RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM65_001RPT.vue?vue&type=style&index=0&id=23dd92d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23dd92d8"]])

export default __exports__